module.exports = __webpack_public_path__ + "img/dashboard-capacity.2a42a31c.svg";